import { render } from "./PeriodsTable.vue?vue&type=template&id=5ec15045&scoped=true"
import script from "./PeriodsTable.vue?vue&type=script&lang=js"
export * from "./PeriodsTable.vue?vue&type=script&lang=js"

import "./PeriodsTable.vue?vue&type=style&index=0&id=5ec15045&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec15045"]])

export default __exports__